import { render, staticRenderFns } from "./yanJiang.vue?vue&type=template&id=87c8983e&scoped=true"
import script from "./yanJiang.vue?vue&type=script&lang=js"
export * from "./yanJiang.vue?vue&type=script&lang=js"
import style0 from "./yanJiang.vue?vue&type=style&index=0&id=87c8983e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c8983e",
  null
  
)

export default component.exports